const validExamStimuli = ["White"];
const validExamGrids = ["G_24_2", "G_24_2_C", "G_30_2"];
const validExamTypes = [
  "FULL_THRESHOLD",
  "STANDARD_THRESHOLD",
  "FAST_THRESHOLD",
];

// filter exams by grid type, algorithm, status
// also add the isRetinaLogikExam field to the objects' properties
export const getValidExams = (exams) => {
  return exams
    ?.filter((exam) => {
      const visualFieldSections = exam?.visualFieldThresholdingSections;

      return (
        validExamGrids.includes(visualFieldSections?.[0]?.gridType) &&
        validExamTypes.includes(visualFieldSections?.[0]?.algorithm) &&
        validExamStimuli.includes(visualFieldSections?.[0]?.stimulusColor) &&
        exam.completionState === "Completed"
      );
    })
    .map((exam) => {
      return { ...exam, isRetinaLogikExam: true };
    });
};

// filter external exams by grid type and algorithm
// also add the isRetinaLogikExam field to the objects' properties
export const getValidExternalExams = (externalExams) => {
  return externalExams
    ?.filter(
      (exam) =>
        validExamGrids.includes(exam.gridType) &&
        validExamTypes.includes(exam.algorithmType)
    )
    .map((exam) => {
      return { ...exam, isRetinaLogikExam: false };
    });
};

// filter the exams on the currently selected eye
export const getFilteredExams = (externalExams, exams, selectedEye) => {
  const filteredExternalExams = externalExams?.filter(
    (exam) => exam.eye === selectedEye
  );
  const filteredRegularExams = exams
    ?.map((exam) => ({
      ...exam,
      visualFieldThresholdingSections:
        exam?.visualFieldThresholdingSections?.filter(
          (section) => section.eye === selectedEye
        ),
    }))
    ?.filter((exam) => exam?.visualFieldThresholdingSections?.length > 0);

  return filteredRegularExams?.concat(filteredExternalExams);
};
